import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { LockDateSection } from '../../../features/settings/lock-date-section'

export const Route = createFileRoute('/_app/settings/lock-date')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'lock-date'),
  component: LockDateSection,
})
